import { Control } from './Control'
import type { AnswerProps } from './types'

function boundOf(bound: number | string | undefined): string | undefined {
  return typeof bound === 'string' ? bound : undefined
}

// DateAnswer answers date. The platform picker is what people already know, and
// it enforces the bounds the question declares before a tap ever reaches the
// server.
export function DateAnswer({ question, value, onChange }: AnswerProps) {
  const min = boundOf(question.min)
  const max = boundOf(question.max)

  const typed = typeof value === 'string' ? value : ''

  return (
    <Control>
      <input
        className="field__control"
        type="date"
        aria-label={question.text}
        value={typed}
        {...(min === undefined ? {} : { min })}
        {...(max === undefined ? {} : { max })}
        onChange={(event) => onChange(event.target.value || undefined)}
      />
    </Control>
  )
}
